// src/pages/about/AboutComponent.jsx
import React, { useEffect, useState } from "react";
import api from "../../api/http";
import "../../styles/about/DespreComponent.css";

const AboutComponent = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    let cancelled = false;

    const fetchAbout = async () => {
      setLoading(true);
      setErrMsg("");

      try {
        const res = await api.get("/about/despre/");
        const data = res.data;

        // suportă array direct sau pagination { results: [...] }
        const list = Array.isArray(data)
          ? data
          : Array.isArray(data?.results)
          ? data.results
          : [];

        if (!cancelled) setItems(list);
      } catch (error) {
        if (!cancelled) {
          console.error("Error fetching about data:", error);
          setErrMsg(
            error?.response?.data?.detail ||
              error?.message ||
              "Eroare la încărcare"
          );
          setItems([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchAbout();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="sr-about">
      <div className="sr-about__container">
        <header className="sr-about__head">
          <h2 className="sr-about__title">Despre noi</h2>

          <p className="sr-about__subtitle">
            Supreme Rentals este o agenție de Închirieri Auto în R. Moldova, care
            are drept scop prestarea serviciilor de nișă, cu o experiență de
            primă clasă.
          </p>
        </header>

        {loading && <p className="sr-about__state">Se încarcă...</p>}

        {!loading && errMsg && <p className="sr-about__state sr-about__state--error">{errMsg}</p>}

        {!loading && !errMsg && items.length === 0 && (
          <p className="sr-about__state">Nu există informații.</p>
        )}

        {!loading && !errMsg && items.length > 0 && (
          <div className="sr-about__list">
            {items.map((item) => {
              const detalii = Array.isArray(item.detalii)
                ? item.detalii
                : Array.isArray(item.detalii_set)
                ? item.detalii_set
                : [];

              return (
                <article className="sr-about__card" key={item.id}>
                  <div className="sr-about__cardHead">
                    <h3 className="sr-about__cardTitle">{item.titlu}</h3>
                  </div>

                  {detalii.length > 0 ? (
                    <ol className="sr-about__ol">
                      {detalii.map((d, idx) => (
                        <li className="sr-about__li" key={d.id ?? idx}>
                          <span className="sr-about__dot" aria-hidden="true" />
                          <span className="sr-about__liText">
                            {d.detali ?? d.text ?? ""}
                          </span>
                        </li>
                      ))}
                    </ol>
                  ) : (
                    <p className="sr-about__empty">Nu există detalii.</p>
                  )}
                </article>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default AboutComponent;